import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  IconButton,
  Collapse,
  Paper,
  Stack,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function FloatingBranchProfile(props) {
  const { city, phone, email, address, nmls, preQualificationLink } = props;
  const [isOpen, setIsOpen] = useState(true);

  const toggleOpen = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '100px',
        left: isOpen ? 20 : 0,
        zIndex: 1500,
        transition: 'left 0.3s ease-in-out',
      }}
    >
      <Paper
        elevation={6}
        sx={{
          width: isOpen ? 260 : 60,
          minHeight: isOpen ? 'auto' : 60,
          bgcolor: 'white',
          borderRadius: 2,
          overflow: 'hidden',
          transition: 'width 0.3s ease',
        }}
      >
        {/* Toggle Button */}
        <Box sx={{ display: 'flex', justifyContent: isOpen ? 'flex-end' : 'center', p: 1 }}>
          <IconButton onClick={toggleOpen} size="small">
            {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>

        {/* Expandable Content */}
        <Collapse in={isOpen}>
          <Box sx={{ px: 2, pb: 2 }}>
            <Typography variant="h6" fontWeight="bold" sx={{ color: 'primary.main' }}>
              {city}
            </Typography>
          {nmls && (
              <Typography variant="body2" sx={{ mb: 1 }}>
                NMLS #{nmls}
              </Typography>
            )}

            <Stack spacing={1}>
              {phone && (
                <Stack direction="row" spacing={1} alignItems="center">
                  <PhoneIcon fontSize="small" />
                  <Typography variant="body2">{phone}</Typography>
                </Stack>
              )}

              {email && (
                <Stack direction="row" spacing={1} alignItems="center">
                  <MailOutlineIcon fontSize="small" />
                  <Typography variant="body2">{email}</Typography>
                </Stack>
              )}

              {address && (
                <Stack direction="row" spacing={1} alignItems="center">
                  <LocationOnIcon fontSize="small" />
                  <Typography variant="body2">{address}</Typography>
                </Stack>
              )}
            </Stack>

            {preQualificationLink && (
              <Button
                variant="contained"
                fullWidth
                sx={{ mt: 2, textTransform: 'none' }}
                color="primary"
                onClick={() =>
                  window.open(
                    preQualificationLink,
                    '_blank',
                    'noopener,noreferrer'
                  )
                }
              >
                Get Pre-Qualified
              </Button>
            )}
          </Box>
        </Collapse>
      </Paper>
    </Box>
  );
}
